import { Loader } from '@lifebit-ai/lds'
import React from 'react'

import * as styles from './AutomatedChecksReRun.styles'

interface AutomatedChecksReportProps {
  reportUrl?: string
  isDownloadingReport: boolean
  isAutoCheckJobFailed: boolean
  onClickViewAutomatedChecksReport: (reportUrl: string) => Promise<void>
}

const AutomatedChecksReport: React.FC<AutomatedChecksReportProps> = ({
  reportUrl,
  isDownloadingReport,
  isAutoCheckJobFailed,
  onClickViewAutomatedChecksReport
}) => {
  if (isDownloadingReport) {
    return (
      <>
        <styles.Label>Automated Checks Report</styles.Label>
        <styles.LoaderWrapper>
          <Loader size="small" text={false} />
          <styles.Value>Downloading report...</styles.Value>
        </styles.LoaderWrapper>
      </>
    )
  }

  if (!reportUrl) {
    return (
      <>
        <styles.Label>Automated Checks Report</styles.Label>
        <styles.Value>-</styles.Value>
      </>
    )
  }

  return (
    <>
      <styles.Label>Automated Checks Report</styles.Label>
      <styles.ViewChecksReportButton
        disabled={isAutoCheckJobFailed}
        onClick={() => onClickViewAutomatedChecksReport(reportUrl)}
      >
        View
      </styles.ViewChecksReportButton>
    </>
  )
}

export default AutomatedChecksReport
